module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote__And__Centre_Alignment"
  }, [_c('span', [_vm._v("For Brian, Bruce and Penny. For all the years they tiptoed while their father was writing.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine__And__Centre_Alignment"
  }, [_c('span', [_vm._v("—Frank Herbert")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Times_New_Roman__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote__And__Centre_Alignment"
  }, [_c('span', [_vm._v("For all those healers who ease our suffering; for people who feed people, then ask of them virtue; for our friends—gratitude and affection.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine__And__Centre_Alignment"
  }, [_c('span', [_vm._v("—Bill Ransom")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e41eab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 69
// module chunks = 0